import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const zinc = {
  50: "#f8f8f8",
  100: "#dddddd",
  200: "#c3c3c3",
  300: "#a8a8a8",
  400: "#8e8e8e",
  500: "#737373",
  600: "#626262",
  700: "#515151",
  800: "#3f3f3f",
  900: "#2e2e2e",
  950: "#1d1d1d"
};
const stone = {
  50: "#fafaf9",
  100: "#f5f5f4",
  200: "#e7e5e4",
  300: "#d6d3d1",
  400: "#a8a29e",
  500: "#78716c",
  600: "#57534e",
  700: "#44403c",
  800: "#292524",
  900: "#1c1917",
  950: "#0c0a09"
}

export const TPLAura = definePreset(Aura, {
  semantic: {
    primary: stone,
  },
  components: {
    button: {
      // PrimeNG 20+ typed tokens: same --p-button-label-font-weight / --p-button-padding-y vars as before.
      // Former top-level border.color/color/background mapped to no CSS var PrimeNG reads, so they were dropped.
      root: {
        label: {
          fontWeight: "600",
        },
        paddingY: "8px",
      },
      outlined: {
        secondary: {
          borderColor: stone["800"],
          color: stone["800"],
        },
      }
    }
  }
});
